/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

/** 
 * We are disabling these rules, 
 * because we DO want to add a click event on a menu's item.
**/

import React, { Component } from 'react';
import PT from 'prop-types';
import { map } from 'lodash';
import { MDCMenu } from './material-design-hacks/mdc-menu';
import { IconButton } from './iconbutton';

export class DropdownMenu extends Component {
    constructor(props) {
        super(props);
        this.mdMenuRef = React.createRef();
    }

    componentDidMount() {
        this.menu = new MDCMenu(this.mdMenuRef.current);
    }

    handleOnOpenMenu() {
        this.menu.open = true;
    }

    createItemList(data) {
        const itemList = map(data, (item, i) => {
            return (
                <li
                    key={"select_" + item.label + i}
                    className="mdc-list-item"
                    aria-selected="false"
                    role="option"
                    data-value={item.label}
                    onClick={item.onClick}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            item.onClick(e);
                        }
                    }}
                    tabIndex={i}
                >
                    {item.label}
                </li>
            );
        });

        return (
            <ul className="rese-select-list mdc-list">
                {itemList}
            </ul>
        );
    }

    render() {
        const options = this.createItemList(this.props.items);
        const icon = (this.props.useIcon) ? 
                     <IconButton icon={{ className: this.props.icon.className,
                                         label: (this.props.icon.label ? this.props.icon.label : ""),
                                         tooltip: (this.props.icon.tooltip ? this.props.icon.tooltip : "")
                                 }}
                                 onClick={this.handleOnOpenMenu.bind(this)}/> 
                   : null;
        return (
            <div className="tk-dropdown-menu"> {/* tk(toolkit)-dropdown-menu because it conflicts with bootstrap's dropdown-menu */}
                {icon}
                <div className="mdc-menu-surface--anchor">
                    <div className="mdc-menu mdc-menu-surface" ref={this.mdMenuRef} style={this.props.menuStyle}>
                        {options}
                    </div>
                </div>
            </div>
        );
    }
}
DropdownMenu.propTypes = {
    useIcon: PT.bool,
    items: PT.array,
    menuStyle: PT.object,
    icon: PT.shape({
        className: PT.string,
        label: PT.string,
        tooltip: PT.string
    })
};
